import Hero from './components/Hero';
import WhatWeDo from './components/WhatWeDo';
import WhatYouGet from './components/WhatYouGet';
import Pricing from './components/Pricing';
import FinalCTA from './components/FinalCTA';
import DataPrivacy from './components/DataPrivacy';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <WhatWeDo />
      <WhatYouGet />
      <Pricing />
      <FinalCTA />
      <DataPrivacy />
      <Footer />
    </div>
  );
}